// Environment variables utility
// This helps with type safety and default values

// IMPORTANT: For static exports with token substitution:
// - Build-time: Use #{TOKEN_*}# placeholders that get baked into the bundle
// - Release-time: Replace these tokens with actual values in the release pipeline

// Log environment variables for debugging
if (typeof window !== "undefined") {
  console.log("Client-side environment variables:")
  console.log("NEXT_PUBLIC_API_URL:", process.env.NEXT_PUBLIC_API_URL)
  console.log("NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT:", process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT)
  console.log("NEXT_PUBLIC_WORKFLOW_API_URL:", process.env.NEXT_PUBLIC_WORKFLOW_API_URL)
  console.log("NEXT_PUBLIC_FBO_REPORT_API_URL:", process.env.NEXT_PUBLIC_FBO_REPORT_API_URL)
  console.log("NEXT_PUBLIC_BASE_PATH:", process.env.NEXT_PUBLIC_BASE_PATH)
  console.log("NEXT_PUBLIC_BUILD_ENV:", process.env.NEXT_PUBLIC_BUILD_ENV)
  console.log("NEXT_PUBLIC_MIXPANEL_TOKEN:", process.env.NEXT_PUBLIC_MIXPANEL_TOKEN)
  console.log("NEXT_PUBLIC_AUTOMATIONS_V2_URL:", process.env.NEXT_PUBLIC_AUTOMATIONS_V2_URL)
  console.log("NEXT_PUBLIC_ONBOARDING_API_URL:", process.env.NEXT_PUBLIC_ONBOARDING_API_URL)
  console.log("NEXT_PUBLIC_ONBOARDING_FORM_URL:", process.env.NEXT_PUBLIC_ONBOARDING_FORM_URL)
  console.log("NEXT_PUBLIC_ATS_SERVICE_URL:", process.env.NEXT_PUBLIC_ATS_SERVICE_URL)
  console.log("NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN:", process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN)
  console.log("NEXT_PUBLIC_ROLLBAR_ENVIRONMENT:", process.env.NEXT_PUBLIC_ROLLBAR_ENVIRONMENT)
}

// Application environment variables
// These will be token placeholders at build time, replaced in release pipeline
export const env = {
  buildId: process.env.NEXT_PUBLIC_BUILD_ID ?? "local",
  buildCommitSha: process.env.NEXT_PUBLIC_BUILD_COMMIT_SHA || undefined,

  // API URL for backend services
  apiUrl: process.env.NEXT_PUBLIC_API_URL || "#{API_URL}#",

  // Admin Service API Endpoint
  adminServiceApiEndpoint: process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT || "#{ADMIN_SERVICE_API_ENDPOINT}#",

  // Workflow Service API Endpoint
  workflowApiUrl: process.env.NEXT_PUBLIC_WORKFLOW_API_URL || "#{WORKFLOW_SERVICE_API_ENDPOINT}#",

  // Build environment
  buildEnv: process.env.NEXT_PUBLIC_BUILD_ENV || "#{BUILD_ENV}#",

  // Base path
  basePath: process.env.NEXT_PUBLIC_BASE_PATH || "#{BASE_PATH}#",

  // Mixpanel tracking token
  mixpanelToken: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || "#{MIXPANEL_TOKEN}#",

  // Automations V2 URL (external)
  automationsV2Url: process.env.NEXT_PUBLIC_AUTOMATIONS_V2_URL || "#{AUTOMATIONS_V2_URL}#",

  // Messages API URL
  messagesApiUrl: process.env.NEXT_PUBLIC_MESSAGES_API_ENDPOINT || "#{MESSAGES_SERVICE_API_ENDPOINT}#",

  // FBO Report API URL
  fboReportApiUrl: process.env.NEXT_PUBLIC_FBO_REPORT_API_URL || "#{REPORTS_API_URL}#",

  // Sync API URL (OB Portal / gorilla-sync)
  syncApiUrl: process.env.NEXT_PUBLIC_SYNC_API_URL || "#{SYNC_API_URL}#",

  // Onboarding Service API URL
  onboardingFormApiUrl: process.env.NEXT_PUBLIC_ONBOARDING_API_URL || "#{ONBOARDING_FORM_API_URL}#",

  // Onboarding Form URL
  onboardingFormUrl: process.env.NEXT_PUBLIC_ONBOARDING_FORM_URL || "#{ONBOARDING_FORM_URL}#",

  // ATS Service API URL
  atsServiceUrl: process.env.NEXT_PUBLIC_ATS_SERVICE_URL || "#{ATS_SERVICE_URL}#",

  // Rollbar error tracking
  rollbarAccessToken: process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN || "#{ROLLBAR_ACCESS_TOKEN}#",
  rollbarEnvironment: process.env.NEXT_PUBLIC_ROLLBAR_ENVIRONMENT || "#{ROLLBAR_ENVIRONMENT}#",
  rollbarEnabled: (process.env.NEXT_PUBLIC_ROLLBAR_ENABLED || "#{ROLLBAR_ENABLED}#") === "true",

}

// Log the final env object for debugging
if (typeof window !== "undefined") {
  console.log("Final env object:", env)
} 